import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter} from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
// import 'typeface-poppins';
import './Components/i18n';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <HelmetProvider>
        <BrowserRouter>
            <App />
        </BrowserRouter>
        </HelmetProvider>
    </React.StrictMode>
);
reportWebVitals();

